import { ErrorImage } from '../../../ErrorImage'

export function ErrorLoggedOutImage() {
  return <ErrorImage src="/images/logged-out-error.png" alt="Error-Logged-Out" />
}
